import React from "react"
import { Helmet } from "react-helmet";
import Layout from "@Components/layout";
import SEO from "@Components/seo";
import OurTeam from "./OurTeam"
import AreaGuideDetails from "./AreaGuideDetails"
import BlogDetails from './BlogDetails'
import { graphql } from 'gatsby'
import { useMatch } from "@reach/router"
import { TEAM_PAGE_URL, AREA_GUIDES_PAGE_URL, BLOGS_PAGE_URL } from "@Components/common/site/constants";
import PageModules from '@Components/modules';
const DefaultTemplate = (props) => {
  const [state, setState] = React.useState({
    showMenu: false
  })

  const PeopleDetails = useMatch(TEAM_PAGE_URL.alias + "/:item/")
  const AreaDetails = useMatch(AREA_GUIDES_PAGE_URL.alias + "/:item/")
  const caseStudiesDetails = useMatch(BLOGS_PAGE_URL.alias + "/:item/")
  // console.log(props.data.glstrapi)
  const Modules = props.data.glstrapi?.article?.Modules
  const Page = props.data.glstrapi?.article
  const Global = props.data.glstrapi.allStrapiFooter?.edges
  const mapData = props.data.glstrapi.mapViewDashboard
  const contactData = props.data.glstrapi.contact
  const Right_box = props.data.glstrapi.rightBox

  if (PeopleDetails !== null) {
    var URL = PeopleDetails.item
    var page_url = TEAM_PAGE_URL.alias.split('/')
    return (
      <OurTeam slug={URL} alias={page_url.pop()} breadCrumPage={Page?.Pagename} />
    )
  }
  else if (caseStudiesDetails !== null) {
    var URL1 = caseStudiesDetails.item
    var page_url1 = BLOGS_PAGE_URL.alias.split('/')
    return (
      <BlogDetails slug={URL1} alias={page_url1.pop()} breadCrumPage={Page?.Pagename} />
    )
  }
  else if (AreaDetails !== null) {
    var URL2 = AreaDetails.item
    var page_url2 = AREA_GUIDES_PAGE_URL.alias.split('/')
    return (
      <AreaGuideDetails slug={URL2} alias={page_url2.pop()} breadCrumPage={Page?.Pagename} />
    )
  }
  else {
    const classNames = ['area-guide-page', 'our-team-page', 'blog-page', 'static-page', 'international-property-page'];
    const css = classNames.includes(Page?.Custom_CSS_Class);
    let breadCrumPage = Page?.Pagename
    if (Page.Layout == "Form_Page") {
      breadCrumPage = null
    }
    return (
      <Layout breadCrumPage={breadCrumPage} breadCrumAlias={Page.Alias} location={props.location} css={css}>
        <SEO title={Page ? Page.Meta_Title : ''} description={Page ? Page.Meta_Description : ''} url={props.location.href} />

        <Helmet
          bodyAttributes={{
            class: `templates-default-template alias-${Page ? Page.Alias : ''} ${Page.Layout} homepage ${Page ? Page.Custom_CSS_Class : ''}`
          }}
        />
        <PageModules
          Modules={Modules}
          Page={Page}
          Global={Global}
          mapData={mapData}
          contactData={contactData}
          Right_box={Right_box}
        />

      </Layout>
    )
  }
}

export default DefaultTemplate


export const pageQuery = graphql`
  query DeafultQuery($id: ID!) {
    glstrapi {
      article(id: $id, publicationState: LIVE) {
        id
        Pagename
        Meta_Description
        Meta_Title
        Similar_Guides_and_Insight
        Youtube_Subscribe
        Custom_CSS_Class
        Layout
        Alias
        ggfx_results {
          transforms
          src_url
          src_cftle
        }
        Right_box {
          Content
          Right_Title
          Cta_Btn_Block {
            Label
            all_menus {
              Alias
            }
          }
        }
        team {
          id
          Email
          Designation
          Name
          Phone
          URL
          imagetransforms
          Image {
            url
            alternativeText
          }
        }
        Modules {
          ... on GLSTRAPI_ComponentComponentReviewBlock {
            __typename
            Review_Title
            Show_Review 
            Video_Url
            Image {
              alternativeText
              url
            }
          }
          ... on GLSTRAPI_ComponentComponentBanner {
            Banner_CTA_1_Label
            Banner_CTA_2_Label
            Banner_CTA_URL1 {
              Alias
            }
            Banner_CTA_URL2 {
              Alias
            } 
            Banner_Content
            Banner_Image {
              alternativeText
              url
              url_sharp {
                childImageSharp {
                  gatsbyImageData(formats: AUTO
                    width: 1500
                    quality: 75
                    layout: FIXED
                    transformOptions: {cropFocus: CENTER, fit: COVER}
                  )
                }
              }
  
            }
            Banner_Title
            Embed_Video_URL
            Right_Video_Image {
              alternativeText
              url
            }
            Show_Review
            Show_Search
            ShowForm
            Show_Tags
            Video_Background_Image {
              url
              alternativeText
            }
            Video_Ask
            Slider {
              Slider_Image {
                alternativeText
                url
                url_sharp {
                  childImageSharp {
                    gatsbyImageData(formats: AUTO
                      width: 1800
                      quality: 75
                      layout: FIXED
                      transformOptions: {cropFocus: CENTER, fit: COVER}
                    )
                  }
                }
    
              }
              Show_Review
            Title
            Banner_Content
            Banner_CTA_2_Label
            Banner_CTA_1_Label
            Banner_CTA_1_URL {
              Alias
            }
            Banner_CTA_2_URL {
              Alias
            }
            }
            Slide
          }
          ... on GLSTRAPI_ComponentComponentTwoColumnBlock {
            CTA_1_Label
            CTA_1_URL {
              Alias
            }
            Content
            Left_Image {
              url
              alternativeText
              url_sharp {
                childImageSharp {
                  gatsbyImageData(formats: AUTO
                    width: 500
                    quality: 75
                    layout: FIXED
                    transformOptions: {cropFocus: CENTER, fit: COVER}
                  )
                }
              }
            }
            Left_Image_Caption
            Right_Image {
              alternativeText
              url
              url_sharp {
                childImageSharp {
                  gatsbyImageData(formats: AUTO
                    width: 550
                    quality: 75
                    layout: FIXED
                    transformOptions: {cropFocus: CENTER, fit: COVER}
                  )
                }
              }
            }
            Right_Image_Caption
            Title
          }
          ... on GLSTRAPI_ComponentComponentConnectBlock {
            CTA_1_Label
            CTA_2_Label
            Content
            Embed_Video_URL
            Video_Ask
            Image{
              url
              alternativeText
            }
            Ready_To_Start_Title
            CTA_1_URL {
              Alias
            }
            CTA_2_URL {
              Alias
            }
          }
          ... on GLSTRAPI_ComponentComponentStaticVideo {
            Embed_Video_URL
            Style_Type
            Image {
              alternativeText
              url
            }
            Upload_Video {
              url
            }
          }
          ... on GLSTRAPI_ComponentComponentCollections {
            id
            Content
            Select_Collection
            Title
            View_More {
              CTA_1_Label
              CTA_1_URL {
                Alias
              }
            }
            Speak_With {
              Email
              Designation
              Name
              Phone
              URL
              Image {
                alternativeText
                url
              }
            }
          }
          ... on GLSTRAPI_ComponentComponentContentWithRightBar {
            id
            Right_Bar_Title
            Content
            List_Type
            Bullet_Points {
              List_item
            }
          }
          ... on GLSTRAPI_ComponentComponentContentBlocks {
            Add_Blocks {
              Alignment
              Content
              Title
              Embed_Video_URL
              Image {
                alternativeText
                url
              }
            }
          }
          ... on GLSTRAPI_ComponentComponentContent {
            Content
            Show_Content
            Share_Button
          }
          ... on GLSTRAPI_ComponentComponentServicesTiles {
            Tiles {
              Tile_Label
              Content
              Title
              Popup_Image {
                alternativeText
                url
              }
              Image {
                alternativeText
                url
              }
              Tile_URL {
                Alias
              }
            }
          }
          ... on GLSTRAPI_ComponentComponentSectionBlock {
            Add_Section_Block {
              Title
              Content
              Embed_Video_URL
              Video_Ask
              Image {
                alternativeText
                url
              }
              Add_Scroll_Button {
                Label
                Scroll_Text
              }
              Add_Start_Button {
                Label
                URL {
                  Alias
                }
              }
            }
          }
          ... on GLSTRAPI_ComponentComponentAddPageContent {
            Add_Content {
              Content_Block
              Video_Url
              Image {
                alternativeText
                url
              }
            }
          }

          ... on GLSTRAPI_ComponentRevampHelpBlock {
            __typename
            id
            HelpTitle :Title
            Content
            Ctas {
              Cta_Label
              Cta_URL {
                URL
                Secondary_URL
                Alias
              }
            }
          }
          ... on GLSTRAPI_ComponentRevampFullContentBlock {
            id
             __typename
            TitleBlock: Title
            Content
            ContentSpacing : Spacing 
             Ctas {
              Cta_Label
              Cta_URL {
                URL
                Secondary_URL
                Alias
              }
            }
          }
          ... on GLSTRAPI_ComponentRevampImageContentBlock {
            id
             __typename
            BackgroundColor
            TitleBlock: Title
            Content
            Spacing
            Image_Position
            Video_Link
            Image {
              url
              alternativeText
            }
             Ctas {
              Cta_Label
              Cta_URL {
                URL
                Secondary_URL
                Alias

              }
            }
          }

          ... on GLSTRAPI_ComponentRevampFaqBlock {
            __typename
            id
            Background
            FAQTitle: Title
            Content
            Ctas {
              Cta_Label
              Cta_URL {
                URL
                Secondary_URL
                Alias
              }
            }
            FAQ_List {
              Question
              Answer
            }
          }
          ... on GLSTRAPI_ComponentRevampStatsModule {
            __typename
            id
            StatsSpacing: Spacing
            Stats {
              Label
              Prefix
              Suffix
              Value
            }
          }
          ... on GLSTRAPI_ComponentRevampContactBlock {
            __typename
            id
            ContactTitle:Title
            Content
            Ctas {
              Cta_Label
              Cta_URL {
                URL
                Secondary_URL
                Alias
              }
            }
            Offices {
              Name
              Phone
              Whatsapp
              Email
              latitude
              longitude
            }
          }
    
            
        }
      }

      mapViewDashboard {
        Latitude
        Longitude
        Percentage
        Property_Change_price
        Property_area_price
        Property_area_text
        Property_change_text
        Property_current_price
        Property_current_text
        Publish
        Sold_count
        Sold_count_text
      }

      rightBox(publicationState: LIVE) {
        Content
        Right_Title
        Cta_Btn_Block_Right {
          Label
          all_menus {
            Alias
          }
        }
      }
      contact(publicationState: LIVE) {
        imagetransforms
        id
        Address
        Email
        Embed_Video_URL
        Latitude
        Longitude
        Opening_Hours
        Phone
        CTA {
          CTA_1_Label
          CTA_1_URL {
            Alias
          }
        }
        Image {
          alternativeText
          url
        }
        speak_with {
          Designation
          Name
          Phone
          Image {
            alternativeText
            url
          }
          URL
        }
        CTA {
          CTA_1_Label
          CTA_1_URL {
            Alias
          }
        }
      }
    
    }


  




  }
`
